// services/delivery.service.ts
import { apiService } from "./../../app.service";

export const deliveryApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Create supplier with location
    createSupplier: builder.mutation({
      query: (data) => ({
        url: "/supplier",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["supplieres"],
    }),

    // ✅ Get suppliers (location handled by backend via setLocationContext)
    fetchSuppliersList: builder.query({
      query: () => ({
        url: "/supplier",
        method: "GET",
      }),
      providesTags: ["supplieres"],
    }),

    // ✅ Create delivery with location
    createDelivery: builder.mutation({
      query: (data) => ({
        url: "/delivery",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["deliveries"],
    }),

    updateDeliveryComment: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/delivery/${id}/comment`,
        method: "PATCH",
        body: { comment },
      }),
      invalidatesTags: ["deliveries"],
    }),

    // ✅ Get deliveries (location handled by backend)
    fetchDeliveriesList: builder.query({
      query: (locationId) => {
        // Optional: Pass locationId as query param if needed
        const params = locationId ? `?locationId=${locationId}` : "";
        return {
          url: `/delivery${params}`,
          method: "GET",
        };
      },
      providesTags: ["deliveries"],
    }),
  }),
});

export const {
  useCreateSupplierMutation,
  useFetchSuppliersListQuery,
  useCreateDeliveryMutation,
  useFetchDeliveriesListQuery,
  useUpdateDeliveryCommentMutation,
} = deliveryApi;